export const calculateAge = (birthDate) => {
    const today = new Date();
    const birthday = new Date(birthDate);

    let age = today.getFullYear() - birthday.getFullYear();

    const hasHadBirthdayThisYear = 
        today.getMonth() > birthday.getMonth() ||
        (today.getMonth() === birthday.getMonth() &&
            today.getDate() >= birthday.getDate());

        if (!hasHadBirthdayThisYear) {
            age --;
        }

        return age;
};